import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  color: ${colors.white};
  margin-top: 32px;

  .title {
    width: 84px;
    min-width: 84px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 1.5px;
    color: ${colors.silver}
  }

  .images {
    display: flex;
    align-items: center;
    column-gap: 16px;
  }

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;


export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .text {
    color: ${colors.white};
    margin: 25px 0 15px 0;
  }

  .list {
    margin-bottom: 20px;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 16px;
  margin: 24px 0 0 0;
`;

export const Item = styled.div`
  width: 100%;

  .title {
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    color: ${colors.silver};
  }

  .description {
    font-size: 14px;
    font-weight: 600;
    text-decoration: ${props => props.crossLine && 'line-through'};
    letter-spacing: 1px;
    ${props => props.warning && `color: ${colors.red};`}
    white-space: normal;
  }
`;

export const CustomerInformationImagesItem = styled.div`
  width: 100px;
  color: ${colors.green};
  display: flex;
  padding: 10px;
  margin: 0 8px;
  cursor: pointer;
  span {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
  }
  & > svg {
    margin-right: 5px;
  }
`;
